import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Spinner } from '../components/Spinner.js';

export const HowToRedirectPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    void navigate('/how-to-do-an-oracle-reading', { replace: true });
  }, [navigate]);

  return (
    <div className="flex justify-center py-12">
      <Spinner size="lg" />
    </div>
  );
};
